import { UserRole } from '@core-lib/enums';
import { ICarpaLight, ICarpa } from '@core-lib/models';
import { IUser } from '@core-lib/models/user.model';
import { createEntityActions } from '@core-lib/store/entity-slice.function';
import { createAction, props } from '@ngrx/store';

const ActionPrefix = 'User';

export const resetUserState = createAction(`RESET [${ActionPrefix}] STATE`);

export const UserActions = createEntityActions<IUser>(ActionPrefix, 'Current');
export const { LoadEntityRequest: LoadUserRequest, LoadEntitySuccess: LoadUserSuccess, LoadEntityFailure: LoadUserFailure } = UserActions;

export const UsersTenantActions = createEntityActions<IUser[]>(ActionPrefix, 'Users Tenant');
export const {
	LoadEntityRequest: LoadUsersTenantRequest,
	LoadEntitySuccess: LoadUsersTenantSuccess,
	LoadEntityFailure: LoadUsersTenantFailure
} = UsersTenantActions;

export const CarpasActions = createEntityActions<ICarpaLight[]>(ActionPrefix, 'Carpa');
export const {
	LoadEntityRequest: LoadCarpasRequest,
	LoadEntitySuccess: LoadCarpasSuccess,
	LoadEntityFailure: LoadCarpasFailure
} = CarpasActions;

export const CurrentCarpaActions = createEntityActions<ICarpa>(ActionPrefix, 'CurrentCarpa');
export const {
	LoadEntityRequest: LoadCurrentCarpaRequest,
	LoadEntitySuccess: LoadCurrentCarpaSuccess,
	LoadEntityFailure: LoadCurrentCarpaFailure
} = CurrentCarpaActions;
